package pt.at.oss.kotlin.manual.storage.common.contactname.middlenames

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * MiddleNamesEntry Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class MiddleNamesEntry(
    var name: String = ""
) : BaseRecord()
